module.exports = __webpack_public_path__ + "static/media/addUser.8911bd95.png";